import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from '../../constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    color: PDF_STYLES_CONSTANTS.COLORS.PRIMARY_DARK,
  },
  titleContent: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.XX_LARGE,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 8,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_BOTTOM_SMALL,
    flexDirection: 'row',
    borderBottom: '0.5 solid #000',
  },
  reportTitle: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.LARGE,
    textAlign: 'left',
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
  },
  description: {
    marginTop: 0,
  },
  diagramImage: {
    width: '70%',
    marginVertical: 6,
  },
  table: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 0,
  },
  column: {
    width: '50%',
    padding: 5,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_BOTTOM_SMALL,
    borderBottom: '0.5 solid #CBCBCB',
  },
  label: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.TINY,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.BOLD,
    width: '40%',
  },
  value: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    fontWeight: 400,
    width: '60%',
  },
  imageContent: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
  },
  plotBlock: {
    marginBottom: 8,
  },
  candelaImage: {
    width: '100%',
    maxHeight: 220,
    objectFit: 'contain',
  },
  illuminanceImage: {
    width: '100%',
    maxHeight: 240,
    objectFit: 'contain',
  },
});

export default styles;
